import { render, staticRenderFns } from "./Notificacao.vue?vue&type=template&id=27d7036a&scoped=true"
import script from "./Notificacao.vue?vue&type=script&lang=js"
export * from "./Notificacao.vue?vue&type=script&lang=js"
import style0 from "./Notificacao.vue?vue&type=style&index=0&id=27d7036a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d7036a",
  null
  
)

export default component.exports